import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/timeout';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/race';
import {ShareDataService} from 'core/data-services/share/share.service';
import {environment} from '@environments/environment';

@Injectable()
export class DataService {
  protected baseUrl: string = `${environment.base_api_uri}/${environment.api_version}/`;
  protected tokens: any;
  userInfo: any;

  constructor(public http: HttpClient, public shareDataService: ShareDataService) {
  }

  protected convertDictionaryToArray(params: any, separater: string) {
    let list = [];
    for (let key in params) {
      list.push(key + separater + params[key].toString());
    }
    return list;
  }

  protected substituteAllTokens(data: string) {
    data = data || '';
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    let currentBranch = this.shareDataService.getCurrentBranch();
    this.tokens = {
      'PARKING_LOT_ID': currentBranch ? currentBranch : this.userInfo ? this.userInfo.parkingLots[0].id : ''
    };
    for (let key in this.tokens) {
      data = data.split(key).join(this.tokens[key]);
    }
    return data;
  }

  protected put(prefix: string, params: any, suffix: string, data: any, option: any, baseUrl?: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let list = this.convertDictionaryToArray(params, '/');
      const endpoint: string = baseUrl || this.baseUrl;
      this.http.put(this.substituteAllTokens(endpoint + prefix + list.join('/') + suffix), data, option)
        .subscribe(res => {
          resolve(res);
        }, error => {
          reject(error);
        });
    });
  }

  protected delete(prefix: string, params: any, suffix: string, baseUrl?: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let list = this.convertDictionaryToArray(params, '/');
      const endpoint: string = baseUrl || this.baseUrl;
      this.http.delete(this.substituteAllTokens(endpoint + prefix + list.join('/') + suffix))
        .subscribe(res => {
          resolve(res);
        }, error => {
          reject(error);
        });
    });
  }

  protected post(prefix: string, params: any, suffix: string, data: any, option: any, baseUrl?: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let list = this.convertDictionaryToArray(params, '/');
      const endpoint: string = baseUrl || this.baseUrl;
      this.http.post(this.substituteAllTokens(endpoint + prefix + list.join('/') + suffix), data, option)
        .subscribe(res => {
          resolve(res);
        }, error => {
          reject(error);
        });
    });
  }

  protected requestExportReport(prefix: string, params: any, suffix: string, data: any, option: any,): Promise<any> {
    return new Promise((resolve, reject) => {
      const list = this.convertDictionaryToArray(params, '/');
      const url: string = this.substituteAllTokens(this.baseUrl + prefix + list.join('/') + suffix);
      const httpObservable = this.http.post(url, data, option);
      const connectTimeoutDuration = 600000; // 10 Minutes
      const totalRequestTimeoutDuration = 720000; // 12 Minutes

      Observable.race(
        httpObservable,
        Observable.timer(connectTimeoutDuration).switchMap(() => {
          return Observable.throw(new Error('Connect timeout exceeded'));
        })
      )
        .timeout(totalRequestTimeoutDuration)
        .subscribe(res => {
          resolve(res);
        }, error => {
          if (error.name === 'TimeoutError') {
            reject(new Error('Total request timeout exceeded'));
          } else if (error.message === 'Connect timeout exceeded') {
            reject(new Error('Connect timeout exceeded'));
          } else {
            reject(error);
          }
        });
    });
  }

  protected get(prefix: string, params: any, suffix: string, baseUrl?: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let list = this.convertDictionaryToArray(params, '/');
      const endpoint: string = baseUrl || this.baseUrl;
      this.http.get(this.substituteAllTokens(endpoint + prefix + list.join('/') + suffix))
        .subscribe(res => {
          resolve(res);
        }, error => {
          reject(error);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data-services/data-service.ts